import Shepherd from 'shepherd.js';
import store from '@/store/store';
import { ALL_TOURS_FINISHED, TOUR_FINISHED, GET_TOUR_STATE } from '@/store/tour/types';
import { i18n } from './vuei18n';

const tourOptions = {
  highlightPadding: 10,
  highlightRadius: 4,
  buttons: {
    cancel: {
      text: 'introBtns.skip',
      secondary: true,
      action: 'cancel',
    },
    back: {
      text: 'introBtns.back',
      action: 'back',
    },
    next: {
      text: 'introBtns.next',
      action: 'next',
    },
    finish: {
      text: 'introBtns.finish',
      action: 'complete',
    },
    allClear: {
      text: 'introBtns.allClear',
      action: 'complete',
    },
  },
};

export const tourLists = {
  mainTour: [
    {
      text: 'eventsAsideIntro.helloMessage',
      buttons: ['cancel', 'next'],
    },
    {
      el: { element: '.events-container', on: 'right' },
      text: 'eventsAsideIntro.events',
      buttons: ['cancel', 'back', 'next'],
    },
    {
      el: { element: '.events-container .sort-list', on: 'right' },
      text: 'eventsAsideIntro.sort',
      buttons: ['cancel', 'back', 'next'],
    },
    {
      el: { element: '.events-container .add-event-btn', on: 'right' },
      text: 'eventsAsideIntro.create',
      buttons: ['cancel', 'back', 'next'],
      highlightRadius: 24,
    },
    {
      el: {
        element: '.operation-panel .operations, .operation-panel .operations-dropdown',
        on: 'bottom',
      },
      text: 'operationPanelIntro.tabs',
      buttons: ['cancel', 'back', 'next'],
    },
    {
      el: { element: '.operation-panel .transaction-panel', on: 'right' },
      text: 'operationPanelIntro.chat',
      buttons: ['cancel', 'back', 'next'],
    },
    {
      el: { element: '.operation-panel .transactions', on: 'top' },
      text: 'operationPanelIntro.create',
      buttons: ['cancel', 'back', 'next'],
    },
    {
      el: { element: '.event-options', on: 'left' },
      text: 'operationPanelIntro.optionsPanel',
      buttons: ['back', 'finish'],
    },
  ],
  createEvent: [
    {
      text: 'createEventIntro.create',
      buttons: ['allClear'],
    },
  ],
  eventFamilies: [
    {
      text: 'eventFamiliesIntro.explanation',
      buttons: ['cancel', 'next'],
    },
    {
      el: { element: '.change-event-families-container .not-in-families', on: 'top' },
      text: 'eventFamiliesIntro.notInFamily',
      buttons: ['cancel', 'back', 'next'],
    },
    {
      el: { element: '.change-event-families-container .new-family', on: 'bottom' },
      text: 'eventFamiliesIntro.create',
      buttons: ['cancel', 'back', 'finish'],
    },
  ],
};

export const productTours = {};

function addTourStep(step, tour, locale, stepIndex) {
  const stepObj = {
    attachTo: step.el,
    text: i18n.t(step.text, locale),
    canClickTarget: false,
    modalOverlayOpeningPadding: step.highlightPadding || tourOptions.highlightPadding,
    modalOverlayOpeningRadius: step.highlightRadius || tourOptions.highlightRadius,
    buttons: [],
  };
  step.buttons.forEach((button) => {
    const { text, secondary, action } = tourOptions.buttons[button];
    stepObj.buttons.push({
      text: i18n.t(text, locale),
      secondary,
      action: tour[action],
    });
  });
  tour.addStep(stepObj, stepIndex);
}

i18n.availableLocales.forEach((locale) => {
  const localeTours = {};
  Object.keys(tourLists).forEach((listName) => {
    const list = tourLists[listName];
    const tour = new Shepherd.Tour({ useModalOverlay: true });
    tour.on('complete', () => {
      store.dispatch(TOUR_FINISHED, listName);
    });
    tour.on('cancel', () => {
      store.dispatch(ALL_TOURS_FINISHED);
    });
    list.forEach((step) => {
      addTourStep(step, tour, locale);
    });
    localeTours[listName] = tour;
    store.dispatch(GET_TOUR_STATE, listName);
  });
  productTours[locale] = localeTours;
});
